


















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/profilExclusion/edit/EditFlux.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { AloProfilExclusion, getDefaultAloProfilExclusion } from '@/models/alo/AloProfilExclusion'

@Component({
  name: 'ReadFlux',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    profilExclusion:{
      type:Object,
      default:getDefaultAloProfilExclusion
    },
    editable:{
      type:Boolean,
      default:true      
    }
  }
})
export default class ReadFlux extends Vue {
  
  private profilExclusion!:AloProfilExclusion
  private loading!:boolean

  get flux(){
    return this.$store.myGetters.flux
  } 

  edit() { (this.$refs.edit as Edit).edit(this.profilExclusion) }

}
